import {Component, OnInit} from "@angular/core"
import { MatDialog } from "@angular/material/dialog";
import { ShowMovieComponent } from "../../../../../src/app/shared/dialogs/show-movie/show-movie.component";
import { DataService } from "../../../../../src/app/shared/services/data.service";
import { LoaderService } from "../../../../../src/app/shared/services/loader/loader.service";
import { Subject } from "rxjs";
import { debounceTime } from "rxjs/operators";
import { UserService } from "../../service/user.service";

@Component({
    selector:'app-video-list',
    templateUrl:'./video-list.component.html',
    styleUrls:['./video-list.component.scss']
})

export class VideoListComponent implements OnInit {

  AllMovies = [];
  lstCountries = [{ id: '0', name: 'All countries',image:'assets/icons/all-countries.svg' }];
  CategoryOptionList = [{ id: '0', name: 'All categories' , image:'' }]
  selectedCountryId = '0';
  selectedCategoryId = ''

  isUserLoggedIn : boolean = false;
  loader = false;

  searchTerm = ''
  searchChanged = new Subject<''>();
  userData = localStorage.getItem('userData');
  userDataRole : number = this.userData ? JSON.parse(this.userData)?.role : 1;

  constructor(public loaderService: LoaderService,
      public dialog: MatDialog,
      public serviceData: DataService,
      private userService : UserService,
  ){
    this.searchChanged.pipe(debounceTime(500)).subscribe((value) => {
      if(this.searchTerm == '' || this.searchTerm.trim() != ''){
        this.loadVideoList()
      }
    });
  }


  ngOnInit(): void {
      this.loadVideoList();
      this.loadVideoCountryList();
      this.loadCategoryList();
      this.userService.isLoggedIn$.subscribe((value)=>{
      this.isUserLoggedIn = value;
      })
  }

  // load videolist api
  loadVideoList() {
    let params = {
      'country': this.selectedCountryId == '0' ? '' : this.selectedCountryId,
      'category' : this.selectedCategoryId,
      'search' : this.searchTerm.trim()
    }
    this.loader = true
    this.serviceData.getVideoList(params).subscribe({
      next:(res) =>{
        this.AllMovies = res['data']['results'];
        // add thumbnail for all videos in left side
        this.movieThumbnailAllvideos(this.AllMovies);
        this.loader = false  
      },
      error:(err) =>{
        console.error(err);
      },
    })
  }

  search(){
    this.searchChanged.next('')
  }

  //  thumbnail creation for left side all videos
  movieThumbnailAllvideos(allmovie) {
    allmovie.forEach(element => {
      let vt = element.link.split('?');
      element['movieThumbnail'] = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
    });
  }

  // get video country list api
  loadVideoCountryList() {
    this.serviceData.getCountryPublicFilter().subscribe({
      next:(res) =>{
        this.lstCountries = [{ id: '0', name: 'All countries' , image:''}];
        let countryList = res['data']['results'].map((country: { name: string; id: string; flag: string }) => {
          return {
            ...country,
            image: country.flag, // rename `flag` to `image`
          };
        });
        this.lstCountries.push(...countryList);
         
      },
      error:(err) =>{
        console.error(err);  
      },
    })
  }

  // get Category list
  loadCategoryList(){
    this.serviceData.getCategoryPublicFilter().subscribe({
      next:(resp) =>{
        this.CategoryOptionList.push(...resp['data']['results']);
      },
      error:(err) =>{
        console.error(err);
      },
    })
  }

  // thumbnail creation for map videos
  movieMakeThumbnail(countywiseData) {
    countywiseData.forEach(country => {
      country.country_videos.forEach(movie => {
        let vt = movie.link.split('?');
        movie['movieThumbnail'] = '//i.ytimg.com/vi/' + vt[0].substring(30) + '/hqdefault.jpg';
        movie['current_slide'] = 0;
      });
    });
  }

  //  country filter
  countryChange(country) {
    this.selectedCountryId = country.id
    this.loadVideoList()
  }

  //  open video showing modal window
  movieClick(movie) {
    this.dialog.open(ShowMovieComponent, {
      disableClose: true,
      width: '800px',
      height: 'auto',
      data: { 'movie': movie, 'quizVideo': false }
    });
  }

  // subject filter
  subjectChange(item) {
    this.selectedCategoryId = item.id
    this.loadVideoList()
  }

  restrictSpace(event: any) {
    if (event.target.selectionStart === 0 && event.code === 'Space') {
      event.preventDefault()
    }
  }

}
